module.exports = __webpack_public_path__ + "static/media/bodor.1db1211b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/Logos_Lieferanten/bodor.png
// module id = 102
// module chunks = 0